module.exports = __webpack_public_path__ + "static/media/modalImg2.7d21d83c.png";